import { VariantSnackbar } from 'app/types/ui/snackbar'

import { atom } from 'recoil'

/** Global snackbar type. */
export const globalSnackberAtom = atom<{
    setShow: (newState: boolean) => void
    variant: VariantSnackbar
    text: string
}>({
    key: 'globalSnackbarAtom',
    /** @type GlobalSnackbarAtom */
    default: {
        setShow: () => {
            /* Empty */
        },
        variant: VariantSnackbar.enum.info,
        text: '',
    },
})
